export const useContact = () => {
  const { $api } = useNuxtApp();
  const sendRequest = async (body: any) => {
    const response = await $api("/general_contact_requests", {
      method: "POST",
      body,
    });
    return response;
  };

  return {
    sendRequest,
  };
};
